import { render, staticRenderFns } from "./FormGridLayout.vue?vue&type=template&id=5ec4fe11&"
import script from "./FormGridLayout.vue?vue&type=script&lang=js&"
export * from "./FormGridLayout.vue?vue&type=script&lang=js&"
import style0 from "./FormGridLayout.vue?vue&type=style&index=0&id=5ec4fe11&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports